export const removeNonNumeric = number => {
  if (number === null || number === undefined) {
    return '';
  }

  const numberStr = number.toString();

  return numberStr.replace(/[^\d.-]/g, '');
};
